import React from 'react';

const Footer = () => {
	return <footer>&copy; 2021 Pickled Phantom Rocks, Inc</footer>;
}

export default Footer;